// Extracted from invoices/index.tsx to keep the grandfathered route under its
// existing line count when adopting the RouteShell wrapper.

import { ChevronLeft, ChevronRight } from "lucide-react";
import type { PageItem } from "./-helpers";

type PaginationProps = {
	page: number;
	totalPages: number;
	pageSize: number;
	total: number;
	pageItems: PageItem[];
	onPageChange: (next: number) => void;
};

export function Pagination(p: PaginationProps) {
	if (p.totalPages <= 1) return null;
	return (
		<div className="flex items-center justify-between border-t border-[#e5e7eb] px-4 py-3">
			<p className="text-xs text-[#6b7280]">
				Showing {(p.page - 1) * p.pageSize + 1}–{Math.min(p.page * p.pageSize, p.total)} of{" "}
				{p.total}
			</p>
			<div className="flex items-center gap-1">
				<button
					type="button"
					onClick={() => p.onPageChange(p.page - 1)}
					disabled={p.page <= 1}
					className="inline-flex h-8 w-8 items-center justify-center rounded border border-[#e5e7eb] bg-white text-[#6b7280] transition-colors hover:bg-[#f8f9fb] disabled:opacity-40"
				>
					<ChevronLeft className="h-3.5 w-3.5" strokeWidth={1.5} />
				</button>
				{p.pageItems.map((item) =>
					item.type === "ellipsis" ? (
						<span key={item.key} className="px-1 text-xs text-[#9ca3af]">
							...
						</span>
					) : (
						<button
							key={item.key}
							type="button"
							onClick={() => p.onPageChange(item.page)}
							className={`inline-flex h-8 w-8 items-center justify-center rounded text-xs font-medium transition-colors ${
								item.page === p.page
									? "bg-[#4f46e5] text-white"
									: "border border-[#e5e7eb] bg-white text-[#6b7280] hover:bg-[#f8f9fb]"
							}`}
						>
							{item.page}
						</button>
					),
				)}
				<button
					type="button"
					onClick={() => p.onPageChange(p.page + 1)}
					disabled={p.page >= p.totalPages}
					className="inline-flex h-8 w-8 items-center justify-center rounded border border-[#e5e7eb] bg-white text-[#6b7280] transition-colors hover:bg-[#f8f9fb] disabled:opacity-40"
				>
					<ChevronRight className="h-3.5 w-3.5" strokeWidth={1.5} />
				</button>
			</div>
		</div>
	);
}
